import {
    LOCALE_PSEUDO,
    LOCALE_DEBUG,
    LOCALE_US,
    LOCALE_DE,
    LOCALE_FR,
    LOCALE_IT,
    LOCALE_ES,
} from '../locales/constants';
import { type Locale } from '../locales/constants';

export const localeSegmentMap: Record<Locale, string> = {
    [LOCALE_US]: '',
    [LOCALE_DE]: 'de',
    [LOCALE_FR]: 'fr',
    [LOCALE_IT]: 'it',
    [LOCALE_ES]: 'es',
    [LOCALE_PSEUDO]: 'pseudo',
    [LOCALE_DEBUG]: 'en-debug',
} as const;

export const localeSegmentList = Object.values(localeSegmentMap);
